export class UploadTimings {
  //
  // Things used by the UploadAnalytics to determine what happened
  //

  get compression() {
    return this._compression;
  }

  compressionDuration() {
    if(!this._compression) { return null; }

    const previousEventTime = this._start;

    return this._compression - previousEventTime;
  }

  completeDuration() {
    return this._complete - this._start;
  }

  //
  // Things used by the uploader, so we can later examine the process
  //

  started() {
    return this._start = this.now();
  }

  compressed() {
    return this._compression = this.now();
  }

  uploaded() {
    return this._upload = this.now();
  }

  completed(callBack) {
    this._complete = this.now();

    typeof callBack == 'function' && callBack(this);

    return this._complete;
  }

  reset() {
    this._start = null;
    this._compression = null;
    this._upload = null;
    this._complete = null;  
  }

  //
  // private
  //

  _start = null;         // process begun
  _compression = null;   // optionally, compressed the image data
  _upload = null;        // pushed the image to the storage endpoint (Slingshot)
  _complete = null;      // all subsequent work, e.g. analytics, done

  now() {
    return Date.now();
  }
}

export default UploadTimings;
